import { useLazyQuery, useMutation } from "@apollo/client";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import {
  editPriceList,
  editPriceListRates,
  getAllPriceList,
  getAllPriceListRates,
} from "../../../../Utils/AllPagesQuriesAndMutations";
import useFetchFormFields from "../../../custom_hooks/useFetchFormFields";
import Button from "../../Button/Button";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import { updateSingleField } from "../../FormInputSectionComponent/formUtils";
import { InputsInTable } from "../../InputInTable/InputsInTable";
import { useModalContext } from "../../Reactportal/ModalContext";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";
import { updateFieldInRow } from "../AddCreditNote/CreditNoteFunctions";
import "./PriceAndRateList.scss";
import { useSelector } from "react-redux";
import { ErrorToast, SuccessToast } from "../../ToastComponent/RectHotToast";
import Loading from "../../Loading/Loading";

const initialHeaders1 = ["CFT Ratio", "Docket Charge", "Min Wgt", "Min Amount", "FOV", "FSC"];
const initialHeaders2 = [
  "From",
  "To",
  "Freight On",
  "Rate",
  "Pickup Charge",
  "Pickup On",
  "Delivery Charge",
  "Delivery On",
];

const fields1 = [
  {
    id: Math.random() * 10,
    name: "CFT",
    Input: true,
    type: "Number",
    value: "",
    _id: "",
  },
  {
    id: Math.random() * 10,
    name: "Docket_Charge",
    Input: true,
    type: "Number",
    value: "",
    _id: "",
  },
  {
    id: Math.random() * 10,
    name: "Min_Wgt",
    Input: true,
    type: "Number",
    value: "",
    _id: "",
  },
  {
    id: Math.random() * 10,
    name: "Min_Amount",
    Input: true,
    type: "Number",
    value: "",
    _id: "",
  },
  {
    id: Math.random() * 10,
    name: "FOV",
    Input: true,
    type: "Number",
    value: "",
    _id: "",
  },
  {
    id: Math.random() * 10,
    name: "FSC",
    Input: true,
    type: "Number",
    value: "",
    _id: "",
  },
];

const fields2 = [
  {
    id: Math.random() * 10,
    name: "From",
    Input: true,
    type: "InputDropForQuery",
    masterName: "City_Search",
    value: "",
    _id: "",
  },
  {
    id: Math.random() * 10,
    name: "To",
    Input: true,
    type: "InputDropForQuery",
    masterName: "City_Search",
    value: "",
    _id: "",
  },
  {
    id: Math.random() * 10,
    name: "Freight_On",
    Input: true,
    type: "Dropdown",
    dropdowndata: ["Weight", "Per Article", "Quantity", "Fixed"],
    value: "",
    _id: "",
  },
  {
    id: Math.random() * 10,
    name: "Rate",
    Input: true,
    type: "Number",
    value: "",
    _id: "",
  },
  {
    id: Math.random() * 10,
    name: "Pickup_Charge",
    Input: true,
    type: "Number",
    value: "",
    _id: "",
  },
  {
    id: Math.random() * 10,
    name: "Pickup_On",
    Input: true,
    type: "Dropdown",
    dropdowndata: ["Weight", "Per Article", "Quantity", "Fixed"],
    value: "",
    _id: "",
  },
  {
    id: Math.random() * 10,
    name: "Delivery_Charge",
    Input: true,
    type: "Number",
    value: "",
    _id: "",
  },
  {
    id: Math.random() * 10,
    name: "Delivery_On",
    Input: true,
    type: "Dropdown",
    dropdowndata: ["Weight", "Per Article", "Quantity", "Fixed"],
    value: "",
    _id: "",
  },
];

const PriceAndRateList = ({ setIsPriceListClicked, PriceListData }) => {
  const formRef = useRef({});
  const Form_Key = "Price_And_Rate_List";
  const { pushModal, popModal } = useModalContext();
  const [FormData, setFormdata] = useState({});
  const [toggle, setToggle] = useState(false);
  const dispatch = useDispatch();
  const [headers1, setheaders1] = useState([...initialHeaders1]);
  const [headers2, setheaders2] = useState([...initialHeaders2]);
  const [priceListTableData, setPriceListTableData] = useState({
    [Math.random() * 10]: fields1,
  });
  const [priceListRatesTableData, setPriceListRatesTableData] = useState({
    [Math.random() * 10]: fields2,
  });
  const FormDataFromRedux = useSelector((store) => store?.FormDataReducer);
  const scrollContainerRef = useRef(null);
  console.log(PriceListData, "PriceListDataPriceListData");
  //Q & M
  const {
    loading: getFormFieldsLoading,
    data: inputFields,
    getFormSectionAndFields,
  } = useFetchFormFields({ Form_Key });

  const [fetchAllPriceList, { loading: getAllPriceListLoading }] = useLazyQuery(getAllPriceList, {
    fetchPolicy: "network-only",
  });
  const [editPriceLists, { loading: editPriceListLoading }] = useMutation(editPriceList);

  const [fetchAllPriceListRates, { loading: getAllPriceListRatesLoading }] = useLazyQuery(getAllPriceListRates, {
    fetchPolicy: "network-only",
  });
  const [editPriceListRate, { loading: editPriceListRatesLoading }] = useMutation(editPriceListRates);

  const PriceListLoadingState =
    getAllPriceListLoading || editPriceListLoading || getAllPriceListRatesLoading || editPriceListRatesLoading;

  const HanldeChangeonForm = (values) => {
    setFormdata((prev) => ({
      ...prev,
      ...values,
    }));
  };

  const handleGo = () => {
    const Service_Type = FormDataFromRedux?.MasterData?.Price_And_Rate_List?.Service_Type?._id;
    fetchAllPriceList({
      variables: {
        priceListMasterId: PriceListData?._id,
        serviceType: Service_Type,
      },
    }).then(({ data }) => {
      let PLDetails = data?.getAllPriceLists;

      if (PLDetails?.length > 0) {
        const transformedData = {};

        PLDetails.forEach((item, idx) => {
          const rowKey = item?._id;
          transformedData[rowKey] = fields1.map((field) => ({
            ...field,
            value: item[field.name] ?? "",
          }));
        });
        setPriceListTableData(transformedData);
      } else {
        // No data from DB, show only one row
        setPriceListTableData({
          [`row_0`]: fields1.map((f) => ({ ...f, value: "" })),
        });
      }
      console.log(PLDetails, "PLDetailsPLDetails");
      fetchAllPriceListRates({
        variables: {
          priceListId: PLDetails[0]?._id,
        },
      }).then(({ data }) => {
        let PLRDetails = data?.getAllPriceListRates;

        if (PLRDetails?.length > 0) {
          const transformedData = {};

          PLRDetails.forEach((item, idx) => {
            dispatch({
              type: "StoreMasterData",
              payload: {
                formkey: "Price_List_Rates",
                data: { [item?._id]: { From: item?.From, To: item?.To } },
              },
            });
            const rowKey = item?._id;
            transformedData[rowKey] = fields2.map((field) => {
              let value = item[field.name] ?? "";

              if (field.name === "From" && item.From?.name) {
                value = item.From.name;
              } else if (field.name === "To" && item.To?.name) {
                value = item.To.name;
              }

              return {
                ...field,
                value,
              };
            });
          });

          // Add one empty row for new entry
          const emptyRowKey = `row_${PLRDetails.length}`;
          transformedData[emptyRowKey] = fields2.map((field) => ({
            ...field,
            value: "",
          }));
          console.log(transformedData, "transformedDatatransformedDatatransformedData");
          setPriceListRatesTableData(transformedData);
        } else {
          // No data from DB, show only one row
          setPriceListRatesTableData({
            [`row_0`]: fields2.map((f) => ({ ...f, value: "" })),
          });
        }
        console.log(PLRDetails, "PLDetailsPLDetails");
      });
    });
  };

  useEffect(() => {
    setToggle(true);
  }, []);

  useEffect(() => {
    if (inputFields) {
      updateSingleField(formRef, "Name", PriceListData?.Name);
    }
  }, [inputFields]);

  useEffect(() => {
    if (toggle) {
      pushModal(Form_Key);
    }
  }, [toggle, Form_Key, pushModal]);

  const handlePriceListInputChange = async (evt, id, rowId) => {
    let updatedData = updateFieldInRow(priceListTableData[rowId], id, evt.target.value);

    setPriceListTableData((prevData) => ({
      ...prevData,
      [rowId]: updatedData,
    }));
  };

  const handlePriceListRatesInputChange = async (evt, id, rowId) => {
    let updatedData = updateFieldInRow(priceListRatesTableData[rowId], id, evt.target.value);

    setPriceListRatesTableData((prevData) => ({
      ...prevData,
      [rowId]: updatedData,
    }));
  };

  const addNewRowOfPriceListRate = () => {
    const newRowKey = `row_${Object.keys(priceListRatesTableData).length}`;
    const newRow = fields2.map((field) => ({
      ...field,
      value: "",
    }));

    setPriceListRatesTableData((prevData) => {
      const updatedData = {
        ...prevData,
        [newRowKey]: newRow,
      };

      setTimeout(() => {
        if (scrollContainerRef.current) {
          scrollContainerRef.current.scrollTo({
            top: scrollContainerRef.current.scrollHeight,
            behavior: "smooth",
          });
        }
      }, 0);

      return updatedData;
    });
  };

  const HandleDeleteRefOfPriceListRate = (rowId) => {
    delete priceListRatesTableData[rowId];
    setPriceListRatesTableData(priceListRatesTableData);
  };

  const submit = async (closeAction) => {
    try {
      const userInputOfPriceList = [];
      const userInputOfPriceListRates = [];
      //price list
      Object.entries(priceListTableData).forEach(([key, row]) => {
        console.log(key, row, "key & row");

        const formattedRow = {};
        const allEmpty = row.every((field) => field.value === "");

        if (!allEmpty) {
          row.forEach((field) => {
            formattedRow[field.name] = field.value;
          });
          formattedRow._id = key;
          formattedRow.Service_Type = FormDataFromRedux?.MasterData?.Price_And_Rate_List?.Service_Type?._id;
          userInputOfPriceList.push(formattedRow);
        }
      });

      const returnResultOfEditedPriceLists = await editPriceLists({
        variables: {
          priceListMasterId: PriceListData?._id,
          userInput: userInputOfPriceList,
        },
      });

      //Price list rates
      Object.entries(priceListRatesTableData).forEach(([key, row]) => {
        const formattedRow = {};
        const allEmpty = row.every((field) => field.value === "");

        if (!allEmpty) {
          row.forEach((field) => {
            formattedRow[field.name] = field.value;
          });
          formattedRow._id = key;
          formattedRow.From = FormDataFromRedux?.MasterData?.Price_List_Rates?.[key]?.From?._id;
          formattedRow.To = FormDataFromRedux?.MasterData?.Price_List_Rates?.[key]?.To?._id;
          userInputOfPriceListRates.push(formattedRow);
        }
      });
      await editPriceListRate({
        variables: {
          priceListId: returnResultOfEditedPriceLists?.data?.editPriceLists?._id,
          userInput: userInputOfPriceListRates,
        },
      });

      SuccessToast("updated price list successfully");
      if (closeAction === "Close") {
        setIsPriceListClicked({ flag: false, data: {} });
      }
    } catch (err) {
      ErrorToast("Error while updating the price list & rates");
    }
  };

  const SaveAndCloseForAdd = () => {
    submit("Close");
  };

  const closeFormFunction = () => {
    popModal(Form_Key);
    setToggle(false);
    setIsPriceListClicked({ flag: false, data: {} });
    ClearSpecificForm(dispatch, Form_Key);
  };

  const isUnlocked = PriceListData?.Is_Lock === "";

  const footerContent = (
    <PortalFooter
      renderContent={() => <></>}
      disabled={false}
      {...(isUnlocked && {
        submitType: "Save",
        submitform: submit,
        SaveAndClose: SaveAndCloseForAdd,
      })}
      Form_key={Form_Key}
      handleformclose={() => {
        closeFormFunction();
        setToggle(!toggle);
      }}
      loadingState={false}
    />
  );

  return (
    <div className="Price_And_Rate_List_Main_Container">
      <Reactportal
        TypeOfPortal={"L. R. Price List Entry"}
        FoooterContent={footerContent}
        open={toggle}
        onClose={closeFormFunction}
        Form_Key={Form_Key}
      >
        {PriceListLoadingState && <div className="loader-line-div" />}
        <div className="formContainer">
          <div className="Price_And_Rate_List_Search_Box_Container">
            <div className="Price_And_Rate_List_Search_Box">
              {inputFields && inputFields?.length > 0 ? (
                inputFields?.map((e) => (
                  <div className="FormSectionParent" key={e?._id}>
                    <div className="PriceAndRateListContainer">
                      <FormInputSectionComponent
                        inputfields={e.fields}
                        Type={e.name}
                        TypeOfPortal={"Edit"}
                        onhandleFormikChange={HanldeChangeonForm}
                        formRef={formRef}
                        formkey={Form_Key}
                      />
                    </div>
                  </div>
                ))
              ) : !getFormFieldsLoading && (inputFields?.message || inputFields?.length === 0) ? (
                <p>No form fields available.</p>
              ) : null}
              {inputFields && (
                <div className="PriceAndRateListContainerGoButton">
                  <Button name="gobutton" text="GO" action={handleGo} />
                </div>
              )}
            </div>
            {PriceListLoadingState ? (
              <Loading />
            ) : (
              <>
                <div className="Price_And_Rate_List_Bill_Table">
                  <div className="Page_Title_Container_For_Price_List">{"Price List"}</div>
                  <InputsInTable
                    title={"CreditNoteData"}
                    headers={headers1}
                    data={priceListTableData}
                    HandleInputChange={handlePriceListInputChange}
                    handleOnFocus={() => {}}
                    formkey={"Price_List"}
                    isDeleteAccess={false}
                  />
                </div>
                <div className="Price_And_Rate_List_Bill_Table">
                  <div className="Page_Title_Container_For_Price_List">{"Price List Rates"}</div>
                  <div className="Price_List_Rates_Table_Container" ref={scrollContainerRef}>
                    <InputsInTable
                      title={"CreditNoteData"}
                      headers={headers2}
                      data={priceListRatesTableData}
                      HandleInputChange={handlePriceListRatesInputChange}
                      handleOnFocus={() => {}}
                      handleDelete={HandleDeleteRefOfPriceListRate}
                      formkey={"Price_List_Rates"}
                    />
                  </div>
                  <Button text="Add" name="modalbutton" action={() => addNewRowOfPriceListRate(FormData)} />
                </div>
              </>
            )}
          </div>
        </div>
      </Reactportal>
    </div>
  );
};

export default PriceAndRateList;
